import React from 'react';
import styled from 'styled-components';

const StyledSpan = styled.span`
  color: ${({ theme }) => theme.token.colorError};
`;

export const RedAsterisk = ({ className }: { className?: string }) => (
  <StyledSpan className={className}>*</StyledSpan>
);
